'use client'

import type { ReactNode } from 'react'

import { HStack, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  productName: string
  productIcon: ReactNode
  benefits: string[]
  eventDescriptions?: string[]
}

const SubscribeSummarySection = ({ productName, productIcon, benefits, eventDescriptions }: Props) => {
  return (
    <VStack className="gap-3">
      <VStack className="gap-2">
        <div className="shrink-0 size-14 flex items-center">{productIcon}</div>
        <Typography size="h3" weight="bold" className="text-[#1C1C1C]">
          {productName}
        </Typography>
      </VStack>

      <VStack className="gap-0.5">
        {benefits.map((benefit, index) => (
          <HStack key={index} className="gap-1.5 items-center">
            <CheckIcon />
            <Typography size="body1" className="text-[#1C1C1C]">
              {benefit}
            </Typography>
          </HStack>
        ))}
      </VStack>

      {eventDescriptions && eventDescriptions.length > 0 && (
        <VStack className="gap-1">
          {eventDescriptions.map((eventText, index) => (
            <HStack
              key={index}
              className="rounded-lg px-3 py-2 gap-1.5 items-center border border-[#FD6771] bg-[#FFF0F1]"
            >
              <span className="text-[10px]">🔥</span>
              <span className="text-[#1C1C1C] text-[14px] font-semibold leading-[22px]">{eventText}</span>
            </HStack>
          ))}
        </VStack>
      )}
    </VStack>
  )
}

const CheckIcon = () => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none" className="shrink-0">
    <path
      d="M4 8.5L6.47487 10.9749L12.1317 5.31802"
      stroke="#6ABE36"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SubscribeSummarySection
